<template>
    <div>
        <Placeholder label="Don't mess this up" />
    </div>
</template>
<script lang="ts">
export default {};
</script>
